import type { CustomContent } from '@/blocks/domain/types/BlockContent/CustomContent';
import type { BlockContentDto } from '@/blocks/application/mappers/blockMapper';
import { fieldsToDto, mapFieldsDto } from '@/blocks/application/mappers/blockFieldsMapper';

type CustomContentDto = Extract<BlockContentDto, { kind: 'custom' }>;

/** `fields` / `sections` map only when the wire carries them, so a legacy `{ title, body_html }` block round-trips byte for byte. */
export function mapCustomContent(dto: CustomContentDto): CustomContent {
  const content: CustomContent = {
    kind: 'custom',
    title: dto.title ?? '',
    bodyHtml: dto.body_html ?? (dto as { bodyHtml?: string }).bodyHtml ?? ''
  };
  if (dto.fields !== undefined) content.fields = mapFieldsDto(dto.fields);
  if (dto.sections !== undefined) content.sections = dto.sections;
  if (dto.pageBreakBefore === true) content.pageBreakBefore = true;
  return content;
}

export function fromCustomContent(content: CustomContent): CustomContentDto {
  const dto: CustomContentDto = { kind: 'custom', title: content.title, body_html: content.bodyHtml };
  if (content.fields !== undefined) dto.fields = fieldsToDto(content.fields);
  if (content.sections !== undefined) dto.sections = content.sections;
  if (content.pageBreakBefore === true) dto.pageBreakBefore = true;
  return dto;
}
